import React from 'react';
import { CardColor } from '../types';
import { TowerCrystal } from '../constants';
import { Language, t } from '../data/translations';
import { useShellLayout } from '../hooks/useShellLayout';

const colorHexMap: Record<CardColor, string> = {
    [CardColor.Red]: '#ef4444', [CardColor.Pink]: '#ec4899', [CardColor.Green]: '#22c55e',
    [CardColor.Black]: '#64748b', [CardColor.Purple]: '#a855f7', [CardColor.Yellow]: '#eab308',
};

const TowerChoiceModal: React.FC<{ onChoose: (color: CardColor) => void, availableTowers: CardColor[], otherPlayerName?: string, otherActionText?: string, language: Language }> = ({ onChoose, availableTowers, otherPlayerName, otherActionText, language }) => {
    const { isMobileShell } = useShellLayout();

    return (
        <div className="absolute inset-0 bg-black/80 backdrop-blur-sm flex flex-col items-center justify-center z-40">
            <div className={`flex items-center justify-center ${isMobileShell ? 'flex-row gap-8 scale-[0.85]' : 'flex-col gap-0'}`}>
                <div className={`flex flex-col items-center justify-center ${isMobileShell ? 'w-1/2 text-left' : 'w-full text-center'}`}>
                    <h2 className="text-4xl font-bold mb-4 text-slate-200 text-shadow-lg leading-tight">{t('ui.claimYourTower', language)}</h2>
                    <p className={`text-slate-400 max-w-md ${isMobileShell ? 'mb-2' : 'mb-8'}`}>{t('ui.towerChoiceDesc', language)}</p>
                    {otherPlayerName && otherActionText && (
                        <div className={`text-slate-400 ${isMobileShell ? 'mt-2' : '-mt-4 mb-6'}`}>{otherPlayerName} {otherActionText}</div>
                    )}
                </div>
                <div className={`grid grid-cols-3 gap-8 ${isMobileShell ? 'w-1/2' : ''}`}>
                    {availableTowers.map(color => (
                        <div key={color} onClick={() => onChoose(color)}
                            className="flex flex-col items-center justify-center gap-3 p-4 cursor-pointer transform hover:scale-110 transition-all duration-300">
                            <TowerCrystal color={color} className="w-20 h-20" />
                            <span className="font-bold text-lg" style={{ color: colorHexMap[color] }}>{t(`term.${color.toLowerCase()}` as any, language)}</span>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default TowerChoiceModal;
